import React from 'react'
import { NextSeo } from 'next-seo'

import ImageTitle from '@/components/imageTitle'
import Meta from '@/components/Meta'
import ContactHome from '@/components/contact/ContactHome'
import Config from '../../site.config'

const Contact = () => {
  const bgImage = '/images/page-title/knowledge_base_banner.jpg'

  return (
    <div>
      <Meta title='Contacto ' />
      <NextSeo
        title='Romikya Labs'
        description={Config.site.description}
        openGraph={{
          url: Config.site.URL,
          title: Config.site.title,
          description: Config.site.description,
          images: [
            {
              url: Config.site.preview,
              width: 424,
              height: 392,
              alt: 'banner',
              type: 'image/png',
            },
          ],
          site_name: 'Romikya Labs',
        }}
      />
      <div className='pt-[5.5rem] lg:pt-24'>
        <ImageTitle image={bgImage} text={'Ponte en contacto con nosotros'} />
        <ContactHome />
      </div>
    </div>
  )
}

export default Contact
